import { render, staticRenderFns } from "./projectContribution.vue?vue&type=template&id=7985fa6b&scoped=true&"
import script from "./projectContribution.vue?vue&type=script&lang=js&"
export * from "./projectContribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7985fa6b",
  null
  
)

export default component.exports